import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {DashboardsModelService} from '../../Models/Dashboards/dashboards-model.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: DashboardsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los paneles dinámicos
   *
   */
  public getDashboards(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getDashboardsDinamicos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener el detalle del panel dinámico
   *
   */
  public getDashboardDetail(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getDashboardDinamico', {}).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }


  /**
   * Obtener los periodos de los paneles
   *
   */
  public getDashboardsPeriods(): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPeriodosFiltros', {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
